import { Container, Box } from '@mui/material'

import { Fragment, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'

import { usePageTracking } from '@services/hooks/useGoogleAnalytics'
import { PAGE_TRACKING_DATA, GA_CONFIG } from '@features/config/analytics'

import * as landingZoneMigrationMapping from '@store/landingZones/Migration/action'

import { useStepper } from '@components/Stepper/use'
import { useLandingZoneMigration } from '@features/hooks/LandingZones/migration'

import { tplRender } from '@services/utils'

import Breadcrumbs from '@components/Breadcrumbs'
import Tile from '@components/Tile'
import Stepper from '@components/Stepper'

import Header from './Components/Header'
import Status from './Components/Status'
import Footer from './Components/Footer'

import Intro from '@views/Landingzones/Migration/Steps/Intro'
import Inter from '@views/Landingzones/Migration/Steps/Inter'
import Internet from '@views/Landingzones/Migration/Steps/Internet'
import Main from '@views/Landingzones/Migration/Steps/Main'
import Finish from '@views/Landingzones/Migration/Steps/Finish'
import Maintenance from '@views/Landingzones/Migration/Steps/Maintenance'

import { HEADER_HEIGHT } from '@services/theme'

export const Migration = () => {
    const match = useParams()
    const store = useStore()

    const dataStore = useSelector(state => state.landingZoneMigration)
    const landingZoneMigrationAction = bindActionCreators(landingZoneMigrationMapping, store.dispatch)

    const [stepPanel, setStepPanel] = useState(<Fragment />)
    const [finished, setFinished] = useState(false)
    const [maintenance, setMaintenance] = useState(false)

    const { getStatus: getMigrationStatus } = useLandingZoneMigration()
    const { steps, computeSelection } = useStepper(dataStore.selected.steps)

    usePageTracking({
        ...GA_CONFIG.default_data,
        ...{
            // eslint-disable-next-line
            page_name: tplRender(PAGE_TRACKING_DATA.lz.firewallMigration.page_name, {lzName: match.id}),
            // eslint-disable-next-line
            page_url: tplRender(PAGE_TRACKING_DATA.lz.firewallMigration.page_url, {lzName: match.id})
        }
    })

    useEffect(() => {
        setFinished(false)
        setMaintenance(false)
        return () =>
        {
            setFinished(false)
            setMaintenance(false)
            setStepPanel(<Fragment />)
            landingZoneMigrationAction.setStep(null)
        }
    }, [])

    useEffect(() => { getMigrationStatus(match.id, true) }, [match])

    useEffect(() => {
        if (dataStore.selected.step === 'inter') {
            computeSelection('inter')
            setStepPanel(<Inter />)
        }
        else if (dataStore.selected.step === 'internet') {
            computeSelection('internet')
            setStepPanel(<Internet />)
        }
        else if (dataStore.selected.step === 'validationInternet') {
            computeSelection('internet', true)
            setStepPanel(<Internet />)
        }
        else if (dataStore.selected.step === 'main') {
            computeSelection('main')
            setStepPanel(<Main />)
        }
        else if (dataStore.selected.step === 'validationMain') {
            computeSelection('main', true)
            setStepPanel(<Main />)
        }
        else if (dataStore.selected.step === 'finished') {
            setFinished(true)
            computeSelection()
            setStepPanel(<Fragment />)
        }
        else if (dataStore.selected.step === 'maintenance') {
            setMaintenance(true)
            computeSelection()
            setStepPanel(<Fragment />)
        }
        else if (dataStore.selected.step === 'intro') {
            computeSelection()
            setStepPanel(<Intro />)
        }
        else setStepPanel(<Fragment />)
    }, [dataStore.selected.step])


    return (
        <Fragment>
            <Breadcrumbs
                routes={[
                    {label: 'Home', link: '/#/home'},
                    {label: 'Landing-zones', link: '/#/landing-zones'},
                    {label: match.id ?? '-', link: `/#/landing-zones/${match.id}/groups`},
                    {label: 'Firewall migration'}
                ]}
            />

            <Box sx={{overflow: 'auto', height: `calc(100dvh - (${HEADER_HEIGHT} + 55px))`}}>
                <Container maxWidth={'md'} sx={{paddingTop: '30px', paddingBottom: '30px'}}>
                    {!maintenance && !finished && (
                        <Tile sx={{p: 0}}>
                            <Header />
                            <Stepper items={steps} sx={{pl: 2, pr: 2}} />
                            <Status />
                            {stepPanel}
                            {dataStore.selected?.displayFooter && (<Footer />)}
                        </Tile>
                    )}

                    {!maintenance && finished && (<Finish />)}

                    {maintenance && (<Maintenance />)}
                </Container>
            </Box>
        </Fragment>
    )
}

export default Migration